import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, input, signal, ViewChild, WritableSignal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { Align, Margin } from '@progress/kendo-angular-popup';
import "@progress/kendo-date-math/tz/all";
import { User } from '@src/app/shared/models';
import * as fromStore from '@src/app/store/conventional';
import { UserMenuComponent } from "../../../../../core/components/user-menu/user-menu.component";
import { PopupComponent } from '../../popup.component';

@Component({
    selector: 'cs-popup-user-settings',
    imports: [
        CommonModule,
        ButtonModule,
        IconsModule,
        PopupComponent,
        LoaderModule,
        LayoutModule,
        ButtonsModule,
        DropDownsModule,
        UserMenuComponent
    ],
    templateUrl: `./popup-user-settings.component.html`
})
export class PopupUserSettingsComponent {
  private store = inject(Store<fromStore.State>);

  @ViewChild('anchor', { static: true }) anchor: ElementRef | undefined;
  public user = input<User>();
  public popupPosition = signal<Align>({ vertical: 'top', horizontal: 'center' })
  public popupMargin = signal<Margin>({ horizontal: 118, vertical: 7 })

  public handleLogout() {
    this.close();
    this.store.dispatch(fromStore.logoutConfirmed());
  }

  public close() {
    (this.anchor as unknown as { showPopup: WritableSignal<boolean> })?.showPopup?.set(false);
  }
}
